import { Component } from '@angular/core';

@Component({
  selector: 'app-p-player-pixels',
  templateUrl: './p-player-pixels.component.html',
  styleUrls: ['./p-player-pixels.component.scss']
})
export class PPlayerPixelsComponent {

}
